export const MIDINNING_AD_ENDED = 'MIDINNING_AD_ENDED';
export const MIDINNING_AD_STARTED = 'MIDINNING_AD_STARTED';

export const midInningAdEndedAction = (adEnded) => (dispatch) => {
    dispatch({
        type: MIDINNING_AD_ENDED,
        adEnded
    });
};

export const midInningAdStartedAction = (adStarted) => (dispatch) => {
    dispatch({
        type: MIDINNING_AD_STARTED,
        adStarted
    });
};

export default midInningAdEndedAction;
